<template>
  <div>
    <div class="md-layout">
      <!-- Freqeuency -->
      <div
        class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-40 md-size-35 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('FREQ') }]">
          <label>Freqeuency</label>
          <md-input
            v-model="settings.freqeuency"
            data-vv-name="FREQ"
            type="text"
            name="FREQ"
            v-validate="modelValidations.required"
          ></md-input>
          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('FREQ')">close</md-icon>
          </slide-y-down-transition>
          <span class="md-suffix">Hz</span>
        </md-field>
      </div>

      <!-- Method -->
      <div
        class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-40 md-size-35 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('METHODE') }]">
          <label>Method</label>
          <md-select
            v-model="settings.methode"
            name="METHODE"
            v-validate="modelValidations.required"
          >
            <md-option value="0">4Quadrant</md-option>
            <md-option value="1">Algo 1</md-option>
            <md-option value="2">Algo 2</md-option>
            <md-option value="3">Algo 3</md-option>
            <md-option value="4">Algo 4</md-option>
          </md-select>
          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('METHODE')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
    </div>

    <!-- Customer -->
    <div class="md-layout">
      <div
        class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-40 md-size-35 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('CUSTOMER') }]">
          <label>Customer</label>
          <md-input v-model="settings.customer" type="text" name="CUSTOMER"></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('CUSTOMER')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <!-- Area -->
      <div
        class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-40 md-size-35 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('AREA') }]">
          <label>Area</label>
          <md-input v-model="settings.area" type="text" name="AREA"></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('AREA')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
    </div>

    <!-- Location -->
    <div class="md-layout">
      <div
        class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-40 md-size-35 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('LOCATION') }]">
          <label>Location</label>
          <md-input v-model="settings.location" type="text" name="LOCATION"></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('LOCATION')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <!-- Address -->
      <div
        class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-40 md-size-35 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('ADDRESS') }]">
          <label>Address</label>
          <md-input v-model="settings.address" type="text" name="ADDRESS"></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('ADDRESS')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
    </div>

    <div class="md-layout">
      <!-- Note 1 -->
      <div
        class="md-layout-item md-xsmall-size-50 md-small-size-25 md-medium-size-25 md-size-25 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('NOTE1') }]">
          <label>Note 1</label>
          <md-input v-model="settings.note1" type="text" name="NOTE1"></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('NOTE1')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <!-- Note 2 -->
      <div
        class="md-layout-item md-xsmall-size-50 md-small-size-25 md-medium-size-25 md-size-25 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('NOTE2') }]">
          <label>Note 2</label>
          <md-input v-model="settings.note2" type="text" name="NOTE2"></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('NOTE2')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <!-- Note 3 -->
      <div
        class="md-layout-item md-xsmall-size-50 md-small-size-25 md-medium-size-25 md-size-25 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('NOTE3') }]">
          <label>Note 3</label>
          <md-input v-model="settings.note3" type="text" name="NOTE3"></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('NOTE3')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <!-- Note 4 -->
      <div
        class="md-layout-item md-xsmall-size-50 md-small-size-25 md-medium-size-25 md-size-25 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('NOTE4') }]">
          <label>Note 4</label>
          <md-input v-model="settings.note4" type="text" name="NOTE4"></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('NOTE4')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
    </div>
  </div>
</template>

<script>
import { SlideYDownTransition } from "vue2-transitions";

export default {
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      settings: {},
      defaultData: {
        freqeuency: "50",
        methode: "0",
        customer: "",
        area: "",
        location: "",
        address: "",
        note1: "",
        note2: "",
        note3: "",
        note4: ""
      },

      modelValidations: {
        none: {},
        number_not_mandatory: {
          regex: /^[0-9]+$/
        },
        required: {
          required: true
        },
        only_number: {
          required: true,
          regex: /^[0-9]+$/
        }
      }
    };
  },
  created() {
    this.restartToDefault();
  },
  methods: {
    restartToDefault() {
      this.$validator.reset();
      this.errors.clear();
      this.settings = Object.assign({}, this.defaultData);
    },
    validate() {
      return this.$validator.validateAll().then(res => {
        if (res) {
          this.$emit("on-validated", true, this.settings);
        }
        return res;
      });
    }
  }
};
</script>

<style></style>